<template>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3>
            <div class="row row-cols-1 row-cols-sm-3 row-cols-md-3">
              <!-- <div class="col">{{direccion.nombre}}</div> -->
              <div class="col">{{form.mes | moment("MMM-YYYYY") }}</div>
              <!-- <div class="col" v-show="form.area">{{form.area}}</div> -->
            </div>
          </h3>

          <a v-show="form.mes" @click="clean(['mes','area','subarea'])">Volver a Histórico</a>
          <span v-show="form.mes && form.area">--</span>
          <a v-show="form.mes && form.area" v-on:click="clean(['area','subarea'])">Salir de área</a>
          <span v-show="form.mes && form.area && form.subarea">--</span>
          <a v-show="form.mes && form.area && form.subarea" v-on:click="clean(['subarea'])">Salir de subárea</a>

          <div v-show="!form.mes">
            <div class="card card--white">
                <div class="card-header">
                    Registro Histórico
                </div>
                <div class="card-body" style="height: 600px">
                  <bar-chart v-if="chartdata_mensual" :chartdata="chartdata_mensual" :options="options_mensual"></bar-chart>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="form.mes" >
        <div class="col-4">
          <div class="card card--white">
              <div class="card-header">
                  <span v-show="form.area">{{form.area}}:</span> Distribución por Clase
              </div>
              <div class="card-body" >
                  <pie-chart v-if="chartdata_torta" :chartdata="chartdata_torta" :options="options_torta"></pie-chart>
                  <table class="table table--secondary table-sm mt-3">
                      <tr>
                          <th>Clase</th>
                          <th v-show="!form.area">Kg OT</th>
                          <th>Kg RGA</th>
                          <th v-show="!form.area">Variacion</th>
                      </tr>
                      <tr v-for="clase in tabla_clase" v-bind:key="clase.id">
                          <td>{{clase.clase}}</td>
                          <td class="text-right" v-show="!form.area">{{clase.kg_orden | formatNumber}}</td>
                          <td class="text-right">{{clase.kg_rga | formatNumber}}</td>
                          <td class="text-right" v-show="!form.area">{{clase.porcentaje | formatNumber }}%</td>
                      </tr>
                  </table>
              </div>
          </div>
        </div>
        <div class="col-8">
          <div class="card card--white" v-show="form.mes && !form.area">
            <div class="card-header">
                Distribución por Área
            </div>
            <div class="card-body">
              <div style="height:400px">
                <bar-chart v-if="chartdata_areas" :chartdata="chartdata_areas" :options="options_areas"></bar-chart>
              </div>
              <table class="table table--secondary table-sm mt-3">
                <tr>
                    <th>Área</th>
                    <th>Kg RGA</th>
                </tr>
                <tr v-for="area in tabla_areas" v-bind:key="area.id">
                    <td>{{area.area}}</td>
                    <td class="text-right">{{area.kg_rga | formatNumber}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="card card--white" v-show="form.mes && form.area && !form.subarea">
            <div class="card-header">
              {{form.area}}: Distribución por Subareas
            </div>
            <div class="card-body" >
              <div style="height:400px">
                <bar-chart v-if="chartdata_subareas" :chartdata="chartdata_subareas" :options="options_subareas"></bar-chart>
              </div>
              <table class="table table--secondary table-sm mt-3">
                  <tr>
                      <th>Subárea</th>
                      <th>Kg RGA</th>
                  </tr>
                  <tr v-for="subarea in tabla_subareas" v-bind:key="subarea.id">
                      <td>{{subarea.subarea}}</td>
                      <td class="text-right">{{subarea.kg_rga | formatNumber}}</td>
                  </tr>
              </table>
            </div>
          </div>
          <div class="card card--white" v-show="form.mes && form.area && form.subarea">
              <div class="card-header">
                  {{form.area}} {{form.subarea}}: Distribución por Producto
              </div>
              <div class="card-body" >
                  <div style="height:400px">
                    <bar-chart v-if="chartdata_productos" :chartdata="chartdata_productos" :options="options_productos"></bar-chart>
                  </div>
                  <table class="table table--secondary table-sm mt-3">
                      <tr>
                          <th>Subárea</th>
                          <th>Kg RGA</th>
                      </tr>
                      <tr v-for="producto in tabla_productos" v-bind:key="producto.id">
                          <td>{{producto.producto}}</td>
                          <td class="text-right">{{producto.kg_rga | formatNumber}}</td>
                      </tr>
                  </table>
              </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
import axios from 'axios'
import BarChart from '@/views/BarChart.vue'
import PieChart from '@/views/PieChart.vue'

import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'Rga',
  components: { BarChart, PieChart },
  props: {
    msg: String
  },
  data () {
    return {
      form: JSON.parse(JSON.stringify(this.$route.query)),
      chartdata_mensual: null,
      chartdata_torta: null,
      chartdata_areas: null,
      chartdata_subareas: null,
      chartdata_productos: null,
      options_mensual: null,
      options_torta: null,
      options_aras: null,
      options_subareas: null,
      options_productos: null,
      datos: null,
      ordenes: null,
      tabla_productos: null,
      tabla_subareas: null,
      tabla_areas: null,
      tabla_clase: null
    }
  },
  methods: {

    clean (params) {
      var self = this
      params.forEach(function (param) {
        delete self.form[param]
      })
      self.form.t = (new Date()).getTime()
      console.log(self.form)
      this.$router.push({
        name: 'Rga',
        params: { id: self.$route.params.id },
        query: self.form
      })
    },
    graficar_mensual () {
      var self = this

      var colores = {
        Basura: '#545454',
        'Recuperables Con Valor': '#A6CE76',
        'Recuperables Sin Valor': '#725840',
        Peligrosos: '#F73434'
      }

      var meses = _.uniq(_.map(self.datos, 'mes'))
      var mesesformato = []
      meses.forEach(function (mes) {
        mesesformato.push(moment(mes).format('MMM YYYY'))
      })
      var datasets = []

      var clases = _.uniq(_.map(self.datos, 'clase'))
      clases.forEach(function (clase) {
        var data = []
        meses.forEach(function (mes) {
          data.push(_.sumBy(_.filter(self.datos, { mes: mes, clase: clase }), 'peso'))
        })

        var color = Object.keys(colores).includes(clase) ? colores[clase] : '#E5E5E5'
        datasets.push(
          {
            label: clase,
            data: data,
            backgroundColor: color
          })
      })

      this.options_mensual = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (e, a) {
          var activePointLabel = this.getElementsAtEvent(e)[0]._model.label
          self.$router.push({
            name: 'Rga',
            query: {
              mes: moment(activePointLabel).format('YYYY-MM-DD')
            }
          })
        },
        title: {
          display: true,
          text: 'Distribución por Clase Mensual'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }

      this.chartdata_mensual = { labels: mesesformato, datasets: datasets }
    },
    tablear_producto () {
      if (!this.form.mes) {
        return
      }
      if (!this.form.area) {
        return
      }

      if (!this.form.subarea) {
        return
      }

      var rgas = _.filter(this.datos, { mes: this.form.mes })
      rgas = _.filter(rgas, { area: this.form.area })
      rgas = _.filter(rgas, { subarea: this.form.subarea })

      var productos = _.uniq(_.map(rgas, 'producto'))
      var data = []
      productos.forEach(function (producto) {
        var d = {
          producto: producto,
          kg_rga: _.sumBy(_.filter(rgas, { producto: producto }), 'peso')
        }
        data.push(d)
      })
      this.tabla_productos = data
    },
    tablear_subarea () {
      if (!this.form.mes) {
        return
      }
      if (!this.form.area) {
        return
      }

      var rgas = _.filter(this.datos, { mes: this.form.mes })
      rgas = _.filter(rgas, { area: this.form.area })

      var subareas = _.uniq(_.map(rgas, 'subarea'))
      var data = []

      subareas.forEach(function (subarea) {
        var d = {
          subarea: subarea,
          kg_rga: _.sumBy(_.filter(rgas, { subarea: subarea }), 'peso')
        }
        data.push(d)
      })

      this.tabla_subareas = data
    },
    tablear_area () {
      if (!this.form.mes) {
        return
      }

      var rgas = _.filter(this.datos, { mes: this.form.mes })
      // rgas = _.filter(rgas, { area: self.form.area })

      var areas = _.uniq(_.map(rgas, 'area'))
      var data = []

      areas.forEach(function (area) {
        var d = {
          area: area,
          kg_rga: _.sumBy(_.filter(rgas, { area: area }), 'peso')
        }
        data.push(d)
      })

      this.tabla_areas = data
    },
    tablear_clase () {
      if (!this.form.mes) {
        return
      }

      var rgas = _.filter(this.datos, { mes: this.form.mes })
      var ordenes = _.filter(this.ordenes, { mes: this.form.mes })

      if (this.form.area) {
        rgas = _.filter(rgas, { area: this.form.area })
        ordenes = _.filter(ordenes, { area: this.form.area })
      }

      var clases = _.uniq(_.uniq(_.map(ordenes, 'clase')).concat(_.uniq(_.map(rgas, 'clase'))))
      var data = []

      clases.forEach(function (clase) {
        var d = {
          clase: clase,
          kg_orden: _.sumBy(_.filter(ordenes, { clase: clase }), 'peso'),
          kg_rga: _.sumBy(_.filter(rgas, { clase: clase }), 'peso')
        }
        d.porcentaje = (d.kg_rga - d.kg_orden) / d.kg_orden * 100
        data.push(d)
      })
      this.tabla_clase = data
    },
    graficar_torta () {
      if (!this.form.mes) {
        return
      }
      var datos = _.filter(this.datos, { mes: this.form.mes })
      var colores = {
        Basura: '#545454',
        'Recuperables Con Valor': '#A6CE76',
        'Recuperables Sin Valor': '#725840',
        Peligrosos: '#F73434'
      }

      var clases = _.uniq(_.map(datos, 'clase'))
      var data = []
      var colors = []
      clases.forEach(function (clase) {
        data.push(_.sumBy(_.filter(datos, { clase: clase }), 'peso'))
        colors.push(Object.keys(colores).includes(clase) ? colores[clase] : '#E5E5E5')
      })
      this.options_torta = {
        title: {
          display: true,
          text: 'Distribución por Clase'
        }
      }

      this.chartdata_torta = { labels: clases, datasets: [{ data: data, backgroundColor: colors }] }
    },
    graficar_area () {
      var self = this
      var datos = _.filter(this.datos, { mes: this.form.mes })
      var colores = {
        Basura: '#545454',
        'Recuperables Con Valor': '#A6CE76',
        'Recuperables Sin Valor': '#725840',
        Peligrosos: '#F73434'
      }

      var datasets = []
      var areas = _.uniq(_.map(this.datos, 'area'))
      var clases = _.uniq(_.map(this.datos, 'clase'))

      clases.forEach(function (clase) {
        var data = []
        areas.forEach(function (area) {
          data.push(_.sumBy(_.filter(datos, { area: area, clase: clase }), 'peso'))
        })

        var color = Object.keys(colores).includes(clase) ? colores[clase] : '#E5E5E5'
        datasets.push(
          {
            label: clase,
            data: data,
            backgroundColor: color
          })
      })

      // if (this.grafico_area) {
      //   this.grafico_area.data.datasets = datasets
      //   this.grafico_area.data.labels = areas
      //   this.grafico_area.update()
      // }

      this.options_areas = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (e, a) {
          if (this.getElementsAtEvent(e).length > 0) {
            var activePointLabel = this.getElementsAtEvent(e)[0]._model.label
            self.$router.push({
              name: 'Rga',
              query: {
                area: activePointLabel,
                mes: self.form.mes
              }
            })
          } else {
            self.$router.push({
              name: 'Rga'
            })
          }
        },
        title: {
          display: true,
          text: 'Distribución por Area'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
      this.chartdata_areas = { labels: areas, datasets: datasets }
    },
    graficar_subarea () {
      var self = this
      var datos = _.filter(self.datos, { mes: this.form.mes, area: this.form.area })
      var colores = {
        Basura: '#545454',
        'Recuperables Con Valor': '#A6CE76',
        'Recuperables Sin Valor': '#725840',
        Peligrosos: '#F73434'
      }

      var datasets = []
      var subareas = _.uniq(_.map(datos, 'subarea'))
      var clases = _.uniq(_.map(datos, 'clase'))

      clases.forEach(function (clase) {
        var data = []
        subareas.forEach(function (subarea) {
          data.push(_.sumBy(_.filter(datos, { subarea: subarea, clase: clase }), 'peso'))
        })

        var color = Object.keys(colores).includes(clase) ? colores[clase] : '#E5E5E5'
        datasets.push(
          {
            label: clase,
            data: data,
            backgroundColor: color
          })
      })

      // if (this.grafico_subarea) {
      //   this.grafico_subarea.data.datasets = datasets
      //   this.grafico_subarea.data.labels = subareas
      //   this.grafico_subarea.update()
      // }

      this.options_subareas = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (e, a) {
          if (this.getElementsAtEvent(e).length > 0) {
            var activePointLabel = this.getElementsAtEvent(e)[0]._model.label
            // this.$route.params.subarea = activePointLabel
            self.$router.push({
              name: 'Rga',
              query: {
                mes: self.form.mes,
                area: self.form.area,
                subarea: activePointLabel
              }
            })
          } else {
            self.$router.push({
              name: 'Rga',
              query: {
                mes: self.form.mes,
                area: self.form.area
              }
            })
          }
        },
        title: {
          display: true,
          text: 'Distribución por Subarea'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }

      this.chartdata_subareas = { labels: subareas, datasets: datasets }
    },
    graficar_producto () {
      var self = this

      var datos = _.filter(this.datos, { mes: this.form.mes, area: this.form.area, subarea: this.form.subarea })

      var datasets = []
      var productos = _.uniq(_.map(datos, 'producto'))

      var data = []
      productos.forEach(function (producto) {
        data.push(_.sumBy(_.filter(datos, { producto: producto }), 'peso'))
      })

      var color = '#E5E5E5'
      datasets.push(
        {
          label: productos,
          data: data,
          backgroundColor: color
        })

      // if (this.grafico_productos) {
      //   this.grafico_productos.data.datasets = datasets
      //   this.grafico_productos.data.labels = productos
      //   this.grafico_productos.update()
      // }

      this.options_productos = {
        responsive: true,
        maintainAspectRatio: false,
        onClick: function (e, a) {
          self.$router.push({
            name: 'Rga',
            query: {
              mes: self.form.mes,
              area: self.form.area
            }
          })
        },
        title: {
          display: true,
          text: 'Distribución por Producto'
        },
        tooltips: {
          mode: 'index',
          intersect: false
        },
        scales: {
          xAxes: [{
            stacked: true
          }],
          yAxes: [{
            stacked: true
          }]
        }
      }
      this.chartdata_productos = { labels: productos, datasets: datasets }
    },
    search () {
      var self = this
      axios.get('/rga/ordenes/' + this.$route.params.id, {
        //   params: { dia: this.form.desde },
      }).then(function (res) {
        self.ordenes = res.data
        //   self.chartdata = self.format_data_pie_chart(res.data.rows)
        axios.get('/rga/' + self.$route.params.id, {
        }).then(function (res) {
          self.datos = res.data
          if (self.form.mes) {
            self.graficar_torta()
            self.graficar_area()
            self.graficar_subarea()
            self.tablear_clase()
            self.tablear_area()
            self.tablear_subarea()
            self.graficar_producto()
            self.tablear_producto()
          } else {
            self.graficar_mensual()
          }
        })
      })
    }
  },
  mounted () {
    this.search()
  }
}
</script>
